import React, { useState } from 'react'
import ImageField from './ImageField';

export default function DynamicImageFields({ title }) {
    const [fields, setFields] = useState([{ image_name: "", image: "" }]);
    const handleAddFields = () => {
        const values = [...fields];
        values.push({ value: '' });
        setFields(values);
    };
    const handleRemoveFields = (index) => {
        const values = [...fields];
        values.splice(index, 1);
        setFields(values);
    };
    const handleChangeInput = (index, event) => {
        const value = [...fields];
        value[index][event.target.name] = event.target.value;
        setFields(value);
    };

    return (
        fields.map((inputField, index) => (
            <div className="row mt-2" key={index}>
                <div className="col-2 mt-2">
                    <div className="form-group">
                        <label>{title}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="image_name"
                            value={inputField.image_name}
                            onChange={(event) => handleChangeInput(index, event)}
                        />
                    </div>
                </div>
                <div className="col-8">
                    <ImageField
                        title="Document"
                        name={`paper-${index}`}
                        id={`paper-${index}`}
                        accepts={[".jpeg", ".png", ".jpg"]}
                        minSize="2480 x 3508"
                    />
                </div>
                <div className="col-2 ">
                    <div className="form-inline mt-4 py-2">
                        <button
                            className="btn btn-danger mr-2"
                            type="button"
                            onClick={() => handleRemoveFields(index)}
                        >
                            <i className="fa fa-trash-o" />
                        </button>
                        <button
                            className="btn btn-primary"
                            type="button"
                            onClick={(event) => handleAddFields(event)}
                        >
                            <i className="fa fa-plus" />
                        </button>
                    </div>
                </div>
            </div>
        ))
    )
}
